import React from 'react';
import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {QUERY_KEYS} from '../../utils/queryKeys';
import {IPresentation} from '../../incase-domain/presentation';
import {removePresentations} from '../../service/presentation';
import {type TypedTranslation} from '../../i18n';

export function useDeletePresentations(
    setPresentationsToDelete?: React.Dispatch<React.SetStateAction<IPresentation[]>>,
    setDeletePresentations?: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenErrorModal?: React.Dispatch<React.SetStateAction<{isOpen: boolean; message: string}>>
): UseMutationResult<IPresentation[], {message: TypedTranslation; roomNames: string[]}, IPresentation[]> {
    const client = useQueryClient();
    const {t} = useTranslation();

    return useMutation((presentationsToDelete) => removePresentations(presentationsToDelete), {
        onSuccess: (presentationsToDelete) => {
            client.invalidateQueries({queryKey: QUERY_KEYS.presentation.lists()});
            if (presentationsToDelete)
                if (presentationsToDelete.length > 1) {
                    toast.success(t('toasts.presentationsSuccessfullyDeleted'));
                } else {
                    toast.success(t('toasts.presentationSuccessfullyDeleted'));
                }
            setDeletePresentations && setDeletePresentations(false);
            setPresentationsToDelete && setPresentationsToDelete([]);
        },
        onError: (error) => {
            if (error.message && error.roomNames) {
                setOpenErrorModal &&
                    setOpenErrorModal({
                        isOpen: true,
                        message: `${t(error.message)} ${error.roomNames}`,
                    });
            } else {
                toast.error(t('toasts.presDeleteFail'));
            }
            setDeletePresentations && setDeletePresentations(false);
            setPresentationsToDelete && setPresentationsToDelete([]);
        },
    });
}
